const FOOTER_NAV_SELECTOR = '.site-footer__nav';
const FOOTER_SOCIAL_SELECTOR = '.site-footer__social';

export function setupFooterNav() {

  // Remove items from main nav if they contain an SVG (social icons)
  const $nav = document.querySelector(FOOTER_NAV_SELECTOR);
  $nav.querySelectorAll('a').forEach(($a) => {
    if ($a.querySelector('svg')) {
      $a.remove();
    }
  });
  
  // Remove items from social nav if they don't contain an SVG (regular links)
  const $social = document.querySelector(FOOTER_SOCIAL_SELECTOR);
  $social.querySelectorAll('a').forEach(($a) => {
    if (!$a.querySelector('svg')) {
      $a.remove();
    }
  });
}